import {
  MediaDraft,
  UploadProgressData,
  IMediaDraft,
  UploadSuccessData,
  IFile,
} from "@home-health-notify/domain";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { CircularProgress } from "@mui/material";
import { useTranslation, OrganizationContext } from "hhn-commons";
import { useSnackbar } from "notistack";
import React, { useContext } from "react";
import { toPhotoFile } from "../../../chats/MediaFiles";
import DisplayAvatarImage from "../../../common/DisplayAvatarImage";
import { AVATAR_SIZE } from "../../../utils/AvatarUtils";
import { uploadToCloudStorage } from "../../../utils/WebCloudStoargeUploader";
import { CameraIconButton, InputPhotoWrapper } from "../UserProfileModal.style";

const InputPhoto = ({
  src,
  name,
  onImageUpload,
}: {
  src?: string;
  name: string;
  onImageUpload: (file: string) => Promise<void>;
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "userProfile" });
  const { selectedOrgUser } = useContext(OrganizationContext);
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [isUploading, setIsUploading] = React.useState(false);
  const [imageSrc, setImageSrc] = React.useState(src);

  React.useEffect(() => {
    setImageSrc(src);
  }, [src]);
  const uploadPhoto = () => {
    fileInputRef.current?.click();
  };
  const onUploadProgress = (uploadProgressData: UploadProgressData) => {};
  const onUploadSuccess = (mediaDraft: IMediaDraft) => {
    return async (uploadSuccessData: UploadSuccessData) => {
      const fileUrl = uploadSuccessData.url;
      await onImageUpload(fileUrl);
      setIsUploading(false);
      setImageSrc(fileUrl);
    };
  };
  const onUploadError = (file: IFile, _error: unknown) => {
    setIsUploading(false);
    enqueueSnackbar(tNs("preview.uploadError"));
  };
  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const fileWithSafePath = Object.assign(file, {
      filePath: URL.createObjectURL(file),
    });
    const photoFile = toPhotoFile(fileWithSafePath);
    const userPhotoFile = new MediaDraft(photoFile, "");
    setIsUploading(true);
    if (selectedOrgUser?.assetManager) {
      selectedOrgUser.assetManager.uploadToSignedUrl(
        userPhotoFile.mediaFile,
        file.name,
        uploadToCloudStorage,
        onUploadProgress,
        onUploadSuccess(userPhotoFile),
        onUploadError,
      );
    } else {
      setIsUploading(false);
      enqueueSnackbar(tNs("preview.uploadError"));
    }
  };

  return (
    <InputPhotoWrapper>
      <DisplayAvatarImage
        avatarSize={AVATAR_SIZE.XLARGE}
        alt={name}
        src={imageSrc}
      />

      <CameraIconButton
        onClick={uploadPhoto}
        disabled={isUploading}
        sx={isUploading ? { backgroundColor: "white !important" } : {}}
      >
        {!isUploading ? <CameraAltIcon /> : <CircularProgress size="30px" />}
      </CameraIconButton>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </InputPhotoWrapper>
  );
};
export default InputPhoto;
